<template>
<div :class="['meal-card-horizontal', { 'click-disabled': isDisabled }]" @click="toDishDetails">
  <div class="meal-card-image" :style="`backgroundImage: url(${dish.imageUrl || dish.imageurl || dish.imageURL})`">
    <span class="is-snack" v-if="isSnack(dish)">Snack</span>
  </div>
  <div class="meal-card-content">
    <h4 class="card-name">
      {{ dish.name || dish.title }}
      <small v-if="dish.hasNutritionInfo">
        {{ $t('lblCarbs') }} {{ formattedMacro(dish, 'carbs').unit }} • {{ $t('lblProtien') }} {{ formattedMacro(dish, 'protein').unit }} •
        {{ $t('lblFat') }} {{ formattedMacro(dish, 'fat').unit }} • {{ $t('lblCalories') }} {{ formattedMacro(dish, 'calories').unit }}
      </small>
    </h4>
  </div>
</div>
</template>

<script>
import { macrosMixin } from 'macrosMixin';
import { authComputed, kitchenDrawerMethods, recipesComputed, recipesMethods } from '@state/helpers';

export default {
  mixins: [macrosMixin],
  components: {},
  props: {
    dish: {
      type: Object,
      required: true,
    },
    isEmbed: {
      type: Boolean,
    },
    platelistLockStatus: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    ...authComputed,
    ...recipesComputed,
    isDisabled() {
      return !this.loggedIn || this.platelistLockStatus.locked;
    },
  },
  mounted() {},
  methods: {
    ...kitchenDrawerMethods,
    ...recipesMethods,
    async toDishDetails() {
      if (!this.isDisabled) {
        if (this.dish.id !== 0) {
          if (this.dish.dishType === 'r') {
            if (!this.cachedRecipesMap[this.dish.id]) {
              await this.getRecipe(this.dish.id);
            }

            this.navigateDeeper({
              title: this.$t('lblRecipe'),
              component: 'RecipeDetail',
              data: this.cachedRecipesMap[this.dish.id],
            });
          } else if (this.dish.dishType === 'm') {
            // TODO: Pending meal implementation mockups
          }
        }
      }
    },
    isSnack(dish) {
      return dish && dish.id && dish.mealTime && dish.mealTime.name === 'Snacks';
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.meal-card-horizontal {
  align-items: center;
  background-color: $color-meal-card-horizontal-bg;
  border-radius: $base-border-radius;
  box-shadow: $color-meal-card-horizontal-shadow;
  display: flex;
  margin-bottom: 0.8rem;

  &:hover {
    cursor: pointer;
  }

  &.click-disabled:hover {
    cursor: default;
  }

  .meal-card-image {
    background-position: center;
    background-size: cover;
    border-bottom-left-radius: $base-border-radius;
    border-top-left-radius: $base-border-radius;
    flex: 1;
    height: 9rem;

    .is-snack {
      background-color: $color-meal-card-snack-bg;
      border: 1px solid $base-border-color;
      border-radius: $base-border-radius;
      color: white;
      left: 5px;
      padding: 5px;
      position: relative;
      top: 10px;
      z-index: 999;
    }
  }

  .meal-card-content {
    flex: 2;
    padding: 0 2rem;
  }

  .card-name {
    color: $color-meal-card-horizontal-title;
    font-weight: bold;
    line-height: 1.7rem;

    small {
      color: $color-meal-card-horizontal-subtitle;
      display: block;
      margin-top: 0.3rem;
    }
  }
}
</style>
